// extracted by mini-css-extract-plugin
export default {"recos":"Zma-z","productCardOverride":"_ma-z","rowHasBadge":"ana-z"};